module.exports = __webpack_public_path__ + "static/media/coupleIcon.69d99551.png";